import { render, staticRenderFns } from "./PrefixModal.vue?vue&type=template&id=7b1d3618&scoped=true&"
import script from "./PrefixModal.vue?vue&type=script&lang=js&"
export * from "./PrefixModal.vue?vue&type=script&lang=js&"
import style0 from "./PrefixModal.vue?vue&type=style&index=0&id=7b1d3618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1d3618",
  null
  
)

export default component.exports